import React, { useContext } from "react";
import { Outlet, Navigate } from "react-router-dom";
import LoginContext from "../store/loginContext";

const ProtectedRoute: React.FC = () => {
  const loginCtx = useContext(LoginContext);
  return loginCtx?.isLogin ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
